export const searchSidebar = () => {
    const sidebar = document.getElementById('search-sidebar');
    const overlay = document.getElementById('overlay');
    const toggleBtn = document.getElementById('search-button');
    const toggleBtnMobile = document.getElementById('search-button-mobile');
    const closeBtn = document.getElementById('closeSidebar');
    if (sidebar) {
        function openSidebar() {
            console.log('sidebar')
            sidebar.classList.add('active');
            overlay.classList.add('active');
        }

        function closeSidebar() {
            sidebar.classList.remove('active');
            overlay.classList.remove('active');
        }

        toggleBtn.addEventListener('click', openSidebar);
        toggleBtnMobile.addEventListener('click', openSidebar);
        closeBtn.addEventListener('click', closeSidebar);
        overlay.addEventListener('click', closeSidebar);
    }
}
